import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllQuestionReport = createAsyncThunk(
  "admin/questionReport",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `/question-report/all?page=${page}&limit=${limit}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteQuestionReport = createAsyncThunk(
  "admin/deleteQuestionReport",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/question-report/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllResultReport = createAsyncThunk(
  "admin/resultReport",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(
        `/result-report/all?page=${page}&limit=${limit}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteResultReport = createAsyncThunk(
  "admin/deleteResultReport",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/result-report/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {};
const reportSlice = createSlice({
  name: "reportSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllQuestionReport.fulfilled, (state, action) => {
      state.questionReport = action.payload.data;
    });
    builder.addCase(getAllResultReport.fulfilled, (state, action) => {
      state.resultReport = action.payload.data;
    });
  },
});
export default reportSlice.reducer;
